import { Button, CircularProgress } from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { db } from "../../firebase";
import DropDownComponentSorted from "../DropDownComponentSorted";

export default function EditRole(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(props.roleUser);

  const handleRoleChange = (event) => {
    setSelectedRole(event);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await updateDoc(doc(db, "roles", props.userId), { role: selectedRole });
      toast.success("Role updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating the role.");
    }
    setIsLoading(false);
    props.closemodal();
  };

  return (
    <div className="roles-modal">
      <div className="roles-modal-header">
        <div>
          <div className="roles-modal-title">Edit role</div>
          <div className="roles-modal-subtitle">{props.userName}</div>
        </div>
        <button
          type="button"
          className="roles-modal-close"
          onClick={props.closemodal}
          aria-label="Close edit role modal"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      <div className="roles-modal-body">
        <div className="roles-modal-field">
          <DropDownComponentSorted
            api="roles"
            title="User role"
            value={selectedRole}
            onChange={handleRoleChange}
          />
        </div>
      </div>

      <div className="roles-modal-footer">
        <Button
          variant="outlined"
          onClick={props.closemodal}
          disabled={isLoading}
          className="roles-modal-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={isLoading}
          className="roles-modal-primary"
        >
          {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save"}
        </Button>
      </div>
    </div>
  );
}
